import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../../utils/axiosInstance';
import ArticleCard from '../components/ArticleCard';
import { FaBookOpen } from 'react-icons/fa'; // 1. Import a suitable icon
import DownloadCard from '../components/DownloadCard';

// A helper function to parse query params
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Download = () => {
  const [blogs, setBlogs] = useState([]);
  const [title, setTitle] = useState('Downloads');
  

 useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const { data } = await axiosInstance.get(`/blogs`);
        setBlogs(data);
      } catch (error) {
        console.error('Error fetching blogs', error);
      }
    };
    fetchBlogs();
  }, []);

  return (
    <div className="container mx-auto p-6">
      {/* --- 2. UPDATED TITLE SECTION --- */}
      <div className="flex items-center justify-center gap-4 mb-8">
        <FaBookOpen className="text-4xl md:text-5xl text-indigo-600" />
        <h1 className="text-3xl md:text-4xl font-bold text-center text-gray-800">
          {title}
        </h1>
      </div>

      {blogs.length > 0 ? (
        <div className="grid grid-cols-1">
          {blogs.map((blog) => {

            if(blog.pdf_drive_link){
return   <DownloadCard key={blog.id} blog={blog} />;
            }
          
})
}
        </div>
      ) : (
        <p className="text-center text-gray-500 mt-12">No articles found.</p>
      )}
    </div>
  );
};

export default Download;